<div class="dci-tab-container">
  <form [formGroup]="tabForm">
    <div class="panel-top">
      <div class="panel-top__control-panel-top">
        <div class="panel-top__control-panel-top__cut-off">
          <label class="cut-off-label">Cut</label>
          <select
            clrSelect
            class="cut-off-dropdown"
            formControlName="cutOff"
            (change)="saveToStorage('cutOff', $any($event.target).value)"
          >
            <option *ngFor="let item of cutOffs" [value]="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="panel-top__control-panel-top__spot">
          <label class="spot-label">Spot</label>

          <div class="panel-top__control-panel-top__spot__text-box-container">
            <input-with-spinner
              [ngClass]="{
                'spot-textbox--manual': spotManualDate,
                'spot-textbox': true
              }"
              formControlName="spot"
              [id]="'spot'"
              [type]="'text'"
            ></input-with-spinner>
          </div>
        </div>

        <div class="panel-top__control-panel-top__incrementor">
          <label class="incrementor-label">Increment</label>
          <input
            class="clr-input incrementor-textbox"
            formControlName="incrementor"
            type="number"
          />
          <select
            clrSelect
            formControlName="pipsPct"
            class="incrementor-dropdown"
          >
            <option *ngFor="let item of pipsPctList" [value]="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="panel-top__control-panel-top__calculate">
          <button
            class="
              panel-top__control-panel-top__calculate__button
              ui-button ui-button__footer
              primary
            "
            [disabled]="
              !tabForm.valid || !controlPanelForm.valid || calculating
            "
            type="button"
            (click)="calculateDci()"
          >
            <ng-container *ngIf="!calculating; else notCalculating">
              Calculate
            </ng-container>

            <ng-template #notCalculating>
              <span class="spinner spinner-sm spinner-inverse"> </span>
            </ng-template>
          </button>
        </div>
        <div class="panel-top__control-panel-top__share"></div>
      </div>
    </div>

    <div class="panel-bottom">
      <div class="panel-bottom__control-panel-left">
        <div
          class="
            panel-bottom__control-panel-left__column
            panel-bottom__control-panel-left__column--expiry-date
          "
          formArrayName="dates"
        >
          <div class="panel-bottom__control-panel-left__column__header">
            Expiration Date
          </div>
          <ng-container *ngFor="let date of dates; let i = index">
            <div class="panel-bottom__control-panel-left__column__row">
              <ng-container [formGroupName]="i">
                <date-with-spinner-info
                  formControlName="expiryDate"
                  [id]="'expiryDate' + i"
                  [info]="datesInfo[i].expiryDate.info"
                ></date-with-spinner-info>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div
          class="panel-bottom__control-panel-left__column"
          formArrayName="dates"
        >
          <div class="panel-bottom__control-panel-left__column__events">
            <ng-container *ngFor="let date of dates; let i = index">
              <div
                class="
                  panel-bottom__control-panel-left__column__events__container
                "
              >
                <a
                  role="tooltip"
                  aria-haspopup="true"
                  class="tooltip tooltip-sm tooltip-top-right"
                >
                  <div class="event-info">
                    <span class="event-info__text">{{
                      tabData.results.values[i]?.events
                    }}</span>
                  </div>
                  <span class="tooltip-content">{{
                    tabData.results.values[i]?.events
                  }}</span>
                </a>
              </div>
            </ng-container>
          </div>
        </div>

        <div
          class="
            panel-bottom__control-panel-left__column
            panel-bottom__control-panel-left__column--settlement-date
          "
          formArrayName="dates"
        >
          <div class="panel-bottom__control-panel-left__column__header">
            Settlement Date
          </div>
          <ng-container *ngFor="let date of dates; let i = index">
            <div class="panel-bottom__control-panel-left__column__row">
              <ng-container [formGroupName]="i">
                <date-with-spinner-info
                  formControlName="settlementDate"
                  [id]="'settlementDate' + i"
                  [info]="datesInfo[i].settlementDate.info"
                ></date-with-spinner-info>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div
          class="panel-bottom__control-panel-left__column"
          formArrayName="dates"
        >
          <div class="panel-bottom__control-panel-left__column__day-difference">
            <ng-container *ngFor="let date of dates; let i = index">
              <div
                class="
                  panel-bottom__control-panel-left__column__day-difference__container
                "
              >
                <span class="event-info__text">{{ dayDifference[i] }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div
        class="panel-bottom__rates-table scrollable-content"
        formArrayName="strikesYields"
      >
        <div class="panel-bottom__rates-table__strikes-yields-container">
          <ng-container
            *ngFor="let strikeOrYield of StrikeYieldsControls; let i = index"
          >
            <div class="strike-yield__container">
              <div class="strike-yield__container__header">
                <clr-input-container>
                  <input
                    class="strike-yield__container__textbox"
                    [formControlName]="i"
                    clrInput
                    (click)="textBoxCaretRestrictionHandler($event, 'click')"
                    (keydown)="
                      textBoxCaretRestrictionHandler($event, 'keydown')
                    "
                    (focus)="selectedPercentField = $event.target"
                    (input)="strikeChanges(i, tabForm.get('pipsPct').value)"
                    (blur)="
                      decimalFormatterOnBlur(strikeOrYield, 'strikeYield', i)
                    "
                  />
                </clr-input-container>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="panel-bottom__rates-table__values-container">
          <div
            class="panel-bottom__rates-table__values-container__row"
            *ngFor="let row of tabData.results.values; let i = index"
          >
            <div
              class="panel-bottom__rates-table__values-container__row__value"
              *ngFor="let value of row.values; let j = index"
            >
              <label
                class="
                  panel-bottom__rates-table__values-container__row__value__label
                "
                [ngClass]="[
                  value
                    | ValueColorsHeapMap
                      : tabData.results.minValue
                      : tabData.results.maxValue
                      : tabData.results.meanValue
                      : true
                ]"
                (click)="openStrategy(i, j, value)"
              >
                <ng-container
                  *ngIf="tabData.resultSolveFor === 'Strike'; else usingYield"
                >
                  {{ value | strikeFormatter: cross }}
                </ng-container>

                <ng-template #usingYield>
                  {{ value | percent: '1.2-2' }}
                </ng-template>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
